module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/ubezpieczenie-komunikacyjne@3x-7f642c47.svg";